import {
  GET_AWAY_LOCATION_LIST,
  GET_LATEST_LOCATION_LIST,
} from "../../../modules/constants";

export function getLatestLocationList(payload) {
  return {
    type: GET_LATEST_LOCATION_LIST,
    payload,
  };
}

export function getAwayLocationList(payload) {
  return {
    type: GET_AWAY_LOCATION_LIST,
    payload,
  };
}
